export class ParseError extends Error {}

const ReservedCharacters = [":", ";", "|", "[", "]"]

/*
 * input: "foo:dog;LIKE|baz[]:cat|baz[]:1;LE"
 *
 * output: [
 *     { name: "foo", array: false, value: "dog", operator: "LIKE"    },
 *     { name: "baz", array: true,  value: "cat", operator: undefined }
 *     { name: "baz", array: true,  value: "1",   operator: "LE"      }
 * ]
 *
 * Splitting the input by pipes ("|") we get pairs. The syntax of each pair is:
 *
 *     ┌────┐            ┌───┐  ┌─────┐
 * ───►│name├─┬────────┬─┤":"├──┤value├─┬───────────────────┬───►
 *     └────┘ │        │ └───┘  └─────┘ │                   │
 *            │ ┌────┐ │                │ ┌───┐  ┌────────┐ │
 *            └─┤"[]"├─┘                └─┤";"├──┤operator├─┘
 *              └────┘                    └───┘  └────────┘
 *
 */
export default class QueryFiltersParser {
    constructor(str) {
        this.str = str
        this.current = 0
    }

    parse() {
        if (this.isAtEnd()) return []
        const filters = this.parseFilters()
        return filters
    }

    parseFilters() {
        const filters = [this.parseFilter()]
        if (this.peek() === "|") {
            this.consume("|")
            return filters.concat(this.parseFilters())
        }
        if (this.current < this.str.length) {
            throw new ParseError(
                `Unexpected text: "${this.str.slice(this.current)}"`
            )
        }
        return filters
    }

    parseFilter() {
        const name = this.parseString()
        if (name.length === 0)
            throw new ParseError(`Expected a valid filter name`)
        let array = false
        if (this.peek() === "[") {
            array = true
            this.consume("[")
            this.consume("]")
        }
        this.consume(":")
        const value = this.parseString()
        let operator = undefined
        if (this.peek() === ";") {
            this.consume(";")
            operator = this.parseString()
        }

        return { name, array, value, operator }
    }

    parseString() {
        let str = ""
        while (!this.isAtEnd()) {
            if (ReservedCharacters.includes(this.peek())) break
            if (this.peek() === "\\") this.consume("\\")
            str += this.str[this.current++]
        }
        return str
    }

    peek() {
        return this.str[this.current]
    }

    consume(char) {
        if (this.isAtEnd() || this.peek() !== char)
            throw new ParseError(`Expected: ${char}`)
        return this.str[this.current++]
    }

    isAtEnd() {
        return this.current >= this.str.length
    }
}
